<template>
  <div id="contact">
    <loader v-if="loaderActive"></loader>
    <div class="container">
      <div class="row">
        <div class="lnb-wrap col-md-3">
          <div class="lnb">
            <h2>고객센터</h2>
            <ul class="lnb-list">
              <li class="item-contact active">제휴/문의 <span class="right-arrow">></span></li>
              <li class="item-contact" @click="$router.push({name: 'notice'})">공지사항 <span class="right-arrow">></span></li>
              <li class="item-contact" @click="$router.push({name: 'faq'})">자주 묻는 질문 <span class="right-arrow">></span></li>
            </ul>
          </div>
        </div>
        <div class="content-wrap col-md-offset-1 col-md-8">
          <div class="row">
            <div class="col-xs-12 padding-0">
              <h3 class="content-title">제휴/문의</h3>
              <form class="contact-form" @submit.prevent="contactSubmit()">
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>회사명</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           data-vv-name="company"
                           v-validate="{required: true}"
                           v-model="contactData['comp_name']"
                           placeholder="예) 해줌"
                           :readonly="user.id">
                    <p class="is-invalid-text">{{ errors.first('company') }}</p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>담당자명</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           data-vv-name="name"
                           v-validate="{required: true}"
                           v-model="contactData['name']"
                           placeholder="예) 홍길동">
                    <p class="is-invalid-text">{{ errors.first('name') }}</p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>담당자 연락처</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                    <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('contact')}]"
                                 data-vv-name="contact"
                                 v-validate="{required: true}"
                                 v-model="contactData['contact']"
                                 :placeholder="'예) 010-0000-0000'"></input-phone>
                    <p class="is-invalid-text">{{ errors.first('contact') }}</p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>담당자 이메일</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                    <input type="text"
                           class="hz-input-default hz-input-lg"
                           data-vv-name="email"
                           v-validate="{required: true, email: true}"
                           v-model="contactData['email']"
                           :placeholder="'예) haezoom@haezoom.com'">
                    <p class="is-invalid-text">{{ errors.first('email') }}</p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>문의유형</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                    <drop-down-list :class="['hz-dropdownlist-lg']"
                                    data-vv-name="inquiryType"
                                    v-validate="{required: true}"
                                    :dataUrl="contactCategoryUrl"
                                    v-model="contactData['category']"></drop-down-list>
                    <p class="is-invalid-text">{{ errors.first('inquiryType') }}</p>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-md-4 col-xs-12">
                    <label>문의내용</label>
                  </div>
                  <div class="col-md-8 col-xs-12">
                <textarea rows="10"
                          class="hz-input-default"
                          style="width: 100%; padding: 16px;"
                          data-vv-name="inquiryMemo"
                          v-validate="{required: true}"
                          v-model="contactData['message']"
                          placeholder="문의내용을 적어주세요."></textarea>
                    <p class="is-invalid-text">{{ errors.first('inquiryMemo') }}</p>
                  </div>
                </div>
                <div class="row" style="padding: 24px 0;">
                  <button type="submit"
                          class="hz-btn-primary hz-btn-lg col-sm-offset-8 col-sm-4 col-xs-12">문의하기</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title" :size="notifyModal.size" :fields="notifyModal.fields"></modal>
  </div>
</template>

<script>
  'use strict'

  import Loader from 'common/components/Loader'
  import InputField from 'common/components/InputText'
  import InputPhone from 'common/components/InputPhone'
  import DropDownList from 'common/components/DropDownList'
  import Modal from 'common/components/Modal'
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api/index'

  export default {
    name: 'contact',
    components: {
      Loader,
      InputPhone,
      InputField,
      DropDownList,
      Modal
    },
    data: function () {
      return {
        loaderActive: false,
        contactData: {
          comp_name: '',
          name: '',
          contact: '',
          category: '',
          email: '',
          message: ''
        },
        contactCategoryUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/index/inquery_category/',
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['입력정보를 확인해주세요.'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
      'user': {
        handler: function (val) {
          if (typeof val.id !== 'undefined') {
            this.initContactData()
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      initContactData: function () {
        const user = this.user

        // 로그인한 유저 일 경우, 기본값을 설정해준다.
        if (typeof user.id !== 'undefined') {
          this.contactData = {
            comp_name: user.comp_name,
            name: user.pic_name,
            contact: user.pic_contact,
            category: '',
            email: user.pic_email,
            message: ''
          }
        }
      },
      contactSubmit: function () {
        const vm = this
        vm.$validator.validateAll()

        // validation 완료 후 문의하기 API 호출
        vm.$nextTick(function () {
          if (vm.errors.any()) {
            vm.$refs.notifyModal.show()
          } else {
            vm.contactUs()
          }
        })
      },
      contactUs: function () {
        const vm = this
        const data = vm.contactData

        // 로더 활성화
        vm.loaderActive = true

        // 고객문의 API 실행
        api.ContactUs(data, response => {
          if (response.error) {
            // 로더 비활성화
            vm.loaderActive = false
            vm.showToastMessage('문의 실패')
            console.log('fail contact us!', response.source)
          } else {
            // 문의유형과 문의내용을 초기화 해준다.
            vm.contactData['category'] = ''
            vm.contactData['message'] = ''

            // 로더 비활성화 및 알림
            vm.loaderActive = false
            vm.showToastMessage('문의 완료')
          }
        })
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')

      // 토큰여부 확인
      if (token) {
        // 토큰 검증 및 갱신 성공 시
        vm.$store.dispatch('inspectToken', token).then((response) => {
          // 문의하기에 사용자 기본정보를 초기화한다.
          vm.initContactData()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  #contact {
    word-break: keep-all;

    ul {
      padding: 0;
      margin: 0;
      list-style: none;
    }

    .container {
      padding: 154px 16px;

      @media (max-width: 991px) {
        padding: 24px 16px;
      }
    }

    // Local Navigation CSS
    .lnb-wrap {
      padding: 0;

      h2 {
        margin: 0;
        font-size: 26px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.23;
        letter-spacing: -1.4px;
        color: #2e3134;
      }

      .lnb-list {
        margin: 40px 0 0;
        cursor: pointer;

        li {
          padding: 16px 8px;
          font-size: 16px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: -0.7px;
          color: #868e96;

          &.active,
          &:hover {
            font-size: 16px;
            font-weight: bold;
            color: #2e3134;
            background-color: #f3f4f8;
          }
        }
      }

      .right-arrow {
        float: right;
        font-weight: bold;
      }
    }

    // CS Center CSS
    .content-wrap {
      margin-top: 56px;
      padding: 0;

      .content-title {
        padding: 24px 0;
        margin: 0;
        font-size: 22px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.18;
        letter-spacing: -1.1px;
        color: #2e3134;
        border-bottom: 2px solid #2e3134;
      }

      .contact-form {
        padding-top: 40px;

        .form-group {
          margin-bottom: 16px;
        }

        .col-md-4, .col-md-8 {
          padding: 0;
        }

        label {
          margin: 0;
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: -0.8px;
          color: $font-color;

          @media (max-width: 991px) {
            line-height: 32px;
          }
        }

        input {
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cscenter/Contact.vue